import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Header } from "../HomeScene";
import exploreBg from "../../assets/images/exploreBg.png";
import btnLight from "../../assets/images/btnLight.png";
import bigBtn from "../../assets/images/addToCartBg.png";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import styles from "./index.module.scss";
import useCart from "../../customHooks/useCart";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import WineDetails from "./wineDetail";
import ViewCart from "../../components/ViewCart";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { sortAscending } from "../../utils";

const WINE_TYPES = [
  {
    title: "VENTURE BEYOND",
    subtitle: "1844 to Evermore",
    id: "venture_beyond",
    text: "Penfolds Venture Beyond",
  },
  {
    title: "PENFOLDS COLLECTION",
    subtitle: "Reaffirmation of the Heart & Soul of Penfolds",
    id: "penfolds_collection",
    text: "Penfolds Collection",
  },
  {
    title: "LUXURY & ICONS",
    subtitle: "The Ultimate Expression of Extraordinary",
    id: "luxury_and_icons",
    text: "Penfolds Luxury & Icons",
  },
  {
    title: "LIMITED EDITIONS",
    subtitle: "In the Spirit of Innovation and  Experimentation",
    id: "limited_editions",
    text: "Penfolds Limited Editions",
  },
];
export const CartView = ({
  tastingList,
  isCartEmpty,
  cart,
  winesList,
  addToCart,
  removeFromCart,
  placeOrder,
  clearCart,
}) => {
  const getCount = (cart) => {
    let count = 0;
    Object.keys(cart).forEach((key) => {
      count += cart[key].count;
    });
    return count;
  };

  return !isCartEmpty ? (
    <div
      className={`${styles.cartInfoCard}  animate__animated animate__flipInX`}
    >
      <div
        className={styles.cartCard}
        style={{
          backgroundImage: `url(${bigBtn})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          width: "602px",
          height: "109px",
        }}
      >
        <div className={styles.cartBtnLeft}>
          <div
            style={{
              fontSize: "24px",
              marginRight: "10px",
            }}
          >
            {getCount(cart)}

            {/* {Object.values(cart[""]).reduce((cur, sum) => sum + cur)} */}
          </div>{" "}
          {getCount(cart) > 1 ? "products " : "product "}
          {/* {Object.values(cart).reduce((cur, sum) => sum + cur) > 1
            ? "products "
            : "product "} */}
          added
        </div>
        <ViewCart
          cart={cart}
          winesList={winesList}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
          placeOrder={placeOrder}
          clearCart={clearCart}
        />
      </div>
    </div>
  ) : null;
};

function ExploreWines({ db }) {
  const [activeType, setActiveType] = useState(WINE_TYPES[0]);
  const [winesList, setWinesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tastingList, setTastingList] = useState([]);
  const [newList, setNewList] = useState([]);
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  let queryTab = searchParams.get("active_tab");

  const activeTab = useCallback(
    (id) => {
      const query = id ? id : queryTab;
      switch (query) {
        case "venture_beyond":
          {
            setActiveType({
              title: "VENTURE BEYOND",
              subtitle: "1844 to Evermore",
              id: "venture_beyond",
            });
            setSearchParams({ active_tab: "venture_beyond" });
          }
          return;
        case "penfolds_collection":
          {
            setActiveType({
              title: "PENFOLDS COLLECTION",
              subtitle: "Reaffirmation of the Heart & Soul of Penfolds",
              id: "penfolds_collection",
            });
            setSearchParams({ active_tab: "penfolds_collection" });
          }

          return;
        case "luxury_and_icons":
          {
            setActiveType({
              title: "LUXURY & ICONS",
              subtitle: "The Ultimate Expression of Extraordinary",
              id: "luxury_and_icons",
            });
            setSearchParams({ active_tab: "luxury_and_icons" });
          }

          return;

        case "limited_editions":
          {
            setActiveType({
              title: "LIMITED EDITIONS",
              subtitle: "In the Spirit of Innovation and  Experimentation",
              id: "limited_editions",
            });
            setSearchParams({ active_tab: "limited_editions" });
          }

          return;
        default:
          {
            setActiveType({
              title: "VENTURE BEYOND",
              subtitle: "1844 to Evermore",
              id: "venture_beyond",
            });
            setSearchParams({ active_tab: "venture_beyond" });
          }
          return;
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [queryTab, setSearchParams]
  );

  const fetchWines = useCallback(async () => {
    let wines = [];
    if (tastingList) {
      setLoading(true);
      const querySnapshot = await getDocs(collection(db, "wines"));
      querySnapshot.forEach((doc) => {
        wines.push(doc.data());
      });

      let newObj = {};
      wines.map((wine) => {
        newObj[wine.name] = wine;
      });

      const _newList = tastingList.filter(
        (wine) => !Object.keys(newObj).includes(wine.name)
      );
      setNewList(_newList);

      // setWinesList([...wines, ...newList]);
      setWinesList(wines);
      setLoading(false);
    }
  }, [db, tastingList]);

  const fetchTastingNotes = useCallback(async () => {
    const docRef = doc(db, "tastingNotes", "Xm6PBat6Jmq9Ap2ckA2d");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setTastingList(docSnap.data().collection);
    } else {
      // console.log("No such document!");
    }
  }, [db]);

  useEffect(() => {
    fetchTastingNotes();
  }, [fetchTastingNotes]);

  // useEffect(() => {

  //   // history.replace(`/?activeTab=${activeType}`)\
  //   navigate({
  //     pathname: '/explore',
  //     search: `?active_tab=${activeType.id}`,
  //   });

  // }, [ activeType, navigate])

  useMemo(() => {
    activeTab();
  }, [activeTab]);

  useEffect(() => {
    fetchWines();
  }, [fetchWines]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const listRef = useRef(null);

  const handleScroll = (direction) => {
    let wineCard = document.getElementById("wineCard");
    listRef.current.scroll({
      left: wineCard?.clientWidth * direction + direction * 50,
      behavior: "smooth",
    });
  };

  const showControls =
    winesList.filter((wine) => wine.type.includes(activeType.title)).length > 4;

  const {
    addToCart,
    cart,
    removeFromCart,
    isCartEmpty,
    placeOrder,
    clearCart,
  } = useCart();

  const innerHeight = window.innerHeight;

  let SortedWinesList = sortAscending(winesList);

  return (
    <div
      className={styles.exploreWrapper}
      style={{
        backgroundImage: `url(${exploreBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        transition: "all ease .8s",
        overflow: "hidden",
        color: "#fff",
        position: "relative",
        overflowY: "hidden",
        maxHeight: innerHeight,
        minHeight: innerHeight,
      }}
    >
      <Header />
      <div className={styles.explore}>
        <div className={styles.left}>
          <div
            style={{
              width: "80%",
              marginTop: 109,
            }}
          >
            <ul>
              {WINE_TYPES.map((type, key) => {
                const isActive = activeType.title === type.title;
                return (
                  <li
                    className={styles.menu_fields}
                    onClick={() => {
                      setLoading(true);
                      // setActiveType(type);
                      activeTab(type.id);

                      setTimeout(() => {
                        setLoading(false);
                      }, 200);
                    }}
                    style={{
                      borderLeftWidth: 13,
                      borderLeftColor: isActive ? "#B12535" : "transparent",
                      borderLeftStyle: "solid",
                      paddingLeft: 56,
                      transition: "border ease .8s",
                      opacity: isActive ? 1 : 0.6,
                      marginTop: 51,
                      fontWeight: isActive ? 700 : 300,
                      
                      cursor: "pointer",
                    }}
                    key={key}
                  >
                    {type.text}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.header}>Explore Our Wines</div>
          <div className={styles.header2}>{activeType.subtitle}</div>
          <div className={styles.carousel}>
            {showControls && (
              <div
                className={`${styles.leftArrow} ${styles.controls}`}
                onClick={() => handleScroll(-1)}
              >
                <img src={require("../../assets/images/left.png")} />
              </div>
            )}
            <div
              className={styles.winelist}
              ref={listRef}
              style={{
                maxHeight: isCartEmpty ? innerHeight - 191 : innerHeight - 325,
              }}
            >
              {!loading &&
                SortedWinesList.map((wine, index) => {
                  const { type, name, subtitle, imgUrl, retail } = wine;
                  if (type.includes(activeType.title)) {
                    return (
                      <div key={index} className={styles.cardWrapper}>
                        {name === "PENFOLDS G4" ?<button
                              style={{
                                background: "none",
                                border: "none",
                                color: "#fff",
                              }}
                            >
                              <div className={styles.wineCard} id="wineCard">
                                <div
                                  className={styles.winecardHeader}
                                  style={{
                                    overflow: "hidden",
                                  }}
                                >
                                  <img
                                    src={imgUrl}
                                    alt={name}
                                    className={`${styles.wineImgMain}  animate__animated animate__bounceInUp`}
                                  />
                                </div>
                                <div className={styles.infoWrapper}>
                                  <div className={styles.wineName}>{name}</div>
                                  {/* <div className={styles.subtitle}>
                                    {subtitle}
                                  </div> */}
                                </div>
                              </div>
                            </button> : <Popup
                          trigger={
                            <button
                              style={{
                                background: "none",
                                border: "none",
                                color: "#fff",
                              }}
                            >
                              <div className={styles.wineCard} id="wineCard">
                                <div
                                  className={styles.winecardHeader}
                                  style={{
                                    overflow: "hidden",
                                  }}
                                >
                                  <img
                                    src={imgUrl}
                                    alt={name}
                                    className={`${styles.wineImgMain}  animate__animated animate__bounceInUp`}
                                  />
                                </div>
                                <div className={styles.infoWrapper}>
                                  <div className={styles.wineName}>{name}</div>
                                  {/* <div className={styles.subtitle}>
                                    {subtitle}
                                  </div> */}
                                </div>
                              </div>
                            </button>
                          }
                          modal
                        >
                          {(close) => (
                            <WineDetails
                              closeModal={close}
                              wineData={wine}
                              addToCart={addToCart}
                              cart={cart}
                              removeFromCart={removeFromCart}
                            />
                          )}
                        </Popup>}
                        <div className={styles.cartBtn}>
                          
                          {cart[name] ? (
                            <div className={styles.addedToCart}>
                              <div
                                className={`${styles.updateBtn} ${styles.btnMinus}`}
                                onClick={() => removeFromCart(name)}
                              >
                                -
                              </div>
                              <div>{cart[name].count}</div>
                              <div
                                className={`${styles.updateBtn} ${styles.btnPlus}`}
                                onClick={() => addToCart(name, retail)}
                              >
                                +
                              </div>
                            </div>
                          ) : (
                            name === "PENFOLDS G4" ? <div
                            className={styles.addBtn}
                            style={{
                              backgroundImage: `url(${btnLight})`,
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "100% 100%",
                              width: "191px",
                              height: "56px",
                            }}
                          >
                     
                            SOLD OUT
                          </div>  : <div
                            className={styles.addBtn}
                            onClick={() => addToCart(name, retail)}
                            style={{
                              backgroundImage: `url(${btnLight})`,
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "100% 100%",
                              width: "191px",
                              height: "56px",
                            }}
                          >
                          
                            Add to cart
                          </div>
                            
                          )}
                        </div>
                      </div>
                    );
                  }
                })}
            </div>
            {showControls && (
              <div
                className={`${styles.rightArrow} ${styles.controls}`}
                onClick={() => handleScroll(2)}
              >
                <img src={require("../../assets/images/right.png")} />
              </div>
            )}
          </div>
        </div>
      </div>
      <CartView
        tastingList={tastingList}
        cart={cart}
        addToCart={addToCart}
        removeFromCart={removeFromCart}
        winesList={[...winesList, ...newList]}
        isCartEmpty={isCartEmpty}
        placeOrder={placeOrder}
        clearCart={clearCart}
      />
    </div>
  );
}

export default ExploreWines;
